import { render } from "./ContentStickers.vue?vue&type=template&id=d80eea0e&scoped=true"
import script from "./ContentStickers.vue?vue&type=script&lang=js"
export * from "./ContentStickers.vue?vue&type=script&lang=js"

import "./ContentStickers.vue?vue&type=style&index=0&id=d80eea0e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d80eea0e"]])

export default __exports__